/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
import { ENVIRONMENT } from 'config';
import { AUTH_URL, REDIRECT_URI, RESPONSE_TYPE, SCOPE } from './keycloak';
/**
 * Keycloak domain
 */
const domain = ENVIRONMENT.KC_DOMAIN;
/**
 * Keycloak realm
 */
const realm = ENVIRONMENT.KC_REALM;
/**
 * Keycloak client id
 */
const clientId = window.location.origin === ENVIRONMENT.APP_URL ?  ENVIRONMENT.KC_CLIENT_ID : ENVIRONMENT.KC_AIRO_CLIENT_ID ;
/**
 * Keycloak login redirect URL
 */
const redirectURL = window.location.origin === ENVIRONMENT.APP_URL ? `${ENVIRONMENT.APP_URL}/${REDIRECT_URI}`: `${ENVIRONMENT.AIRO_APP_URL}/${REDIRECT_URI}`;
/**
 * Keycloak PKCE challenge method
 */
const pkceChallengeMethod = ENVIRONMENT.KC_PKCE_CHALLENGE_METHOD;

/**
 * Built authentication URL
 */
export const authenticationUrl = `${domain}/realms/${realm}/${AUTH_URL}?client_id=${clientId}&response_type=${RESPONSE_TYPE}&redirect_uri=${redirectURL}&scope=${SCOPE}&code_challenge_method=${pkceChallengeMethod}`;

export const samlUrl = `${domain}/realms/${realm}/protocol/saml/clients/preferred-saml-client`;

